<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="state_list" class="elevation-1 mytable" dense :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>State</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                            </v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>
                                    Add State
                                </v-btn>
                            </template>

                            <v-card>
                                <v-form v-model="valid">

                                    <!-- Title -->
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <!-- <v-row>
                                                <v-col cols="12">
                                                    <v-autocomplete :items="country_super_master_list" item-text="name"
                                                        v-model="editedItem.country" label="Select Country"
                                                        :rules="[(v) => !!v || 'Required']"
                                                        :disabled="editedIndex != -1" />
                                                </v-col>
                                            </v-row> -->

                                            <v-row>
                                                <v-col cols="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="state_super_master_list" item-text="name"
                                                        v-model="addedItem.state_super_master" return-object
                                                        label="Select State" :rules="[(v) => !!v || 'Required']" />
                                                </v-col>

                                                <v-col cols="12" v-else>
                                                    <v-text-field v-model.trim="editedItem.name" label="State"
                                                        :rules="[(v) => !!v || 'Required']" disabled />
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="12" v-if="editedIndex == -1">
                                                    <v-text-field label="State In Unicode"
                                                        v-model="addedItem.state_super_master.unicode_name" />
                                                </v-col>

                                                <v-col cols="12" v-else>
                                                    <v-text-field label="State In Unicode"
                                                        v-model="editedItem.unicode_state" />
                                                </v-col>
                                            </v-row>

                                            <v-row v-if="editedIndex != -1">
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active" />
                                                </v-col>
                                            </v-row>

                                            <v-row v-if="editedIndex == -1">
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="newcheckbox" color="success"
                                                        label="State not present in above list? Add new here..." />
                                                </v-col>
                                            </v-row>

                                            <v-row v-if="editedIndex == -1 && newcheckbox">
                                                <v-col cols="12">
                                                    <v-autocomplete :items="country_super_master_list" item-text="name"
                                                        v-model="newStateCountry" label="Select Country"
                                                        :rules="[(v) => !!v || 'Required']" />
                                                </v-col>

                                                <v-col cols="12">
                                                    <v-text-field v-model.trim="newState" label="New State"
                                                        ref="newState" />
                                                </v-col>

                                                <v-col cols="12">
                                                    <v-text-field label="New State In Unicode"
                                                        v-model="unicode_new_state" />
                                                </v-col>

                                                <v-col cols="12">
                                                    <v-btn class="mb-2 button" color="primary" small
                                                        @click="saveNewState">
                                                        Save New State
                                                    </v-btn>
                                                </v-col>
                                            </v-row>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer />
                                        <v-btn class="mb-2 button" text @click="close">
                                            Cancel
                                        </v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">
                                            Save
                                        </v-btn>
                                    </v-card-actions>

                                </v-form>
                            </v-card>
                        </v-dialog>

                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                        <v-avatar size="25" class="delete-avatar ml-2">
                            <v-icon class="delete-v-icon" @click="deleteItem(item)">mdi-delete</v-icon>
                        </v-avatar>
                    </div>
                </template>
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        valid: false,
        overlay: false,
        errorMsg: {
            state: false,
        },
        addedItem: {
            state_super_master: "",
        },
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        newcheckbox: false,
        newStateCountry: "",
        newState: "",
        unicode_new_state: "",
        headers: [
            {
                text: "State",
                align: "left",
                sortable: false,
                value: "name",
            },
            {
                text: "State In Unicode",
                align: "left",
                sortable: false,
                value: "unicode_state",
            },
            {
                text: "Active",
                align: "left",
                sortable: true,
                value: "isactive",
            },
            { text: "Actions", value: "action", sortable: false },
        ],
        state_list: [],
        country_super_master_list: [],
        state_super_master_list: [],
        editedIndex: -1,
        editedItem: {
            id: "",
            name: "",
            unicode_state: "",
            country: null,
            isactive: "",
        },
        defaultItem: {
            id: "",
            name: "",
            unicode_state: "",
            country: null,
            isactive: "",
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New State" : "Edit State";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();

            if (!val) {
            this.resetForm();
            }
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
        this.getCountries();
        this.getSuperMasterStates();
    },
    methods: {

        editItem(item) {
            this.editedIndex = this.state_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        onLoad() {
            axios
                .post("/AdmissionMaster/getStates")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.state_list = res.data.state_list
                        }
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },

        getCountries() {
            axios
                .post("/AdmissionMaster/country")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.country_super_master_list = res.data.country_super_master_list_name;
                        }
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },

        getSuperMasterStates() {
            axios
                .post("/AdmissionMaster/getSuperMasterState")
                .then((res) => {
                    if (res.data.msg == "200") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.state_super_master_list = res.data.state_super_master_list;
                        }
                    } else {
                        window.console.log(res.data.msg);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },

        saveNewState() {
            if (this.newState == null || this.newState == "" || this.newStateCountry == null || this.newStateCountry == "") {
                this.showSnackbar("#b71c1c", "Please add above fields!");
                return;
            }
            let data = {
                newState: this.newState,
                unicode_new_state : this.unicode_new_state,
                newStateCountry : this.newStateCountry
            };
            this.overlay = true;
            axios
                .post("/AdmissionMaster/addNewState", data)
                .then((res) => {
                    this.newState = "";
                    this.newcheckbox = false;
                    this.overlay = false;
                    this.newStateCountry = "";
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "State Added Successfully!!!"); 
                        this.onLoad();
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#b71c1c", "State Already Present!"); 
                    }
                })
                .catch((error) => {
                    this.overlay = false;
                    window.console.log(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
            this.close();
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
            this.newcheckbox = false;
            this.newState = "";
            this.unicode_new_state = "";
        },

        save() {
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/editState", this.editedItem)
                        .then((res) => {
                            if (res.data.code === "SUCCESS") {
                                Object.assign(this.state_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "State Updated Successfully...");
                                this.onLoad();
                            } else if (res.data.code == "NA") {
                                this.showSnackbar("#b71c1c", "State Already Present!!!");
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            } else {
                axios
                    .post("/AdmissionMaster/saveState", this.addedItem)
                    .then((res) => {
                        if (res.data.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "State Added Successfully!!!");
                            this.onLoad();
                        } else if (res.data.code == "NA") {
                            this.showSnackbar("#b71c1c", "State Already Present!!!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
                this.close();
            }
        },

        deleteItem(item) {
            const data = {
                id: item.id,
                name: item.name
            }
            axios
                .post("/AdmissionMaster/deleteState", data)
                .then((res) => {
                    if (res.data.code == "SUCCESS") {
                        this.showSnackbar("#4caf50", "State Deleted Successfully!!!");
                        this.onLoad();
                    } else if (res.data.code == "NA") {
                        this.showSnackbar("#b71c1c", res.data.msg || "State Not Present!!!");
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                });
        },

        isValidated() {
            if (this.editedIndex > -1) {

                if (!this.editedItem.name) {
                    this.showSnackbar("#b71c1c", "Enter state name!!!");
                    return false;
                }
                return true;
            }
            else {

                if (!this.addedItem.state_super_master) {
                    this.showSnackbar("#b71c1c", "Select a state!!!");
                    return false;
                }

                return true;
            }
        },
        resetForm() {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.addedItem = { state_super_master: "" };
            this.newcheckbox = false;
        }
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}
</style>
